export function calculateAvailableOptions(filterableFields, initialOptions, activeFilters) {
    /**
     * Calculates the available filter options cased on initial data and currently active filters.
     *
     * */

    if ( filterableFields.length === 0 || Object.keys(initialOptions).length === 0 ) {
        // if there are no filterable fields or initial options set we want to return an empty object
        // as we lack enough data to calculate available options.
        // Note: we do this early to save performing unneeded calculations.
        return {}

    }

    const availableOptions = {};
    filterableFields.map(field => {

        if ( !( field.name in initialOptions ) ) {
            // the field isn't in the options so we should skip it.
            return
        }

        let fieldOptions = [ ...initialOptions[field.name] ];  // copy so we don't mutate the original

        if ( activeFilters.length > 0 ) {
            // because there are active filters we need to remove any items in the active filters from available options.

            // extract the list of values for active filters for the current field
            const activeFieldOptions = activeFilters
                .filter(item => item.field === field.name)
                .map(item => item.value);

            fieldOptions = fieldOptions.filter(option => activeFieldOptions.indexOf(option) === -1)  // -1 means the option is not in the array
        }

        // we want to always append the field options even if it is an empty array.
        availableOptions[field.name] = fieldOptions;

    });

    return availableOptions
}
